"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    {
        type: 'textfield',
        input: true,
        key: 'dataFormat',
        label: 'Data Format',
        placeholder: 'HH:mm:ss',
        tooltip: 'The moment.js format for saving the value of this field.',
        weight: 25,
    },
];
